import { Account } from "redux-models/reduxStateTypes";
import { CONTENT_CATEGORIES, CONTENT_URL_PATHS } from "utils/constants/content";

const loggedInNavOptions = (account: Account, isMindMatrixEnabled: boolean) => {
  type itemType = {
    name: string;
    text?: string;
    link: string;
    comingSoon?: boolean;
    inNewTab?: boolean;
    items: itemType[];
  };

  type navType = Omit<itemType, "name" | "link"> & {
    text: string;
    items: itemType[];
    name?: string;
    link?: string;
  };

  const nav: navType[] = [
    {
      text: "Applications",
      items: [
        { name: "Apply", link: "/apply-all" },
        { name: "Refer Your Client", link: "/apply-and-refer" },
        { name: "View Application Status", link: "/applications" },
        { name: "View Applications by Applicant", link: "/companies" },
      ] as itemType[],
    },
    {
      text: "Client Management",
      items: [
        {
          text: "Asset Finance",
          items: [
            {
              name: "Payout Figure",
              link: "/client-management/asset-finance/payout",
            },
            {
              name: "Customer Statement",
              link: "/client-management/asset-finance/statement",
            },
          ],
        },
      ] as itemType[],
    },
    {
      text: "Tools",
      items: [
        { name: "Asset Finance Quote", link: "/create-quote" },
        {
          name: "Working Capital Calculator",
          link: "/working-capital-calculator-av",
        },
        { name: "Product Selector", link: "/product-selector-tool" },
        account.idTokenClaims.role === "admin" && {
          name: "Fast Doc Configuration",
          link: "/fast-doc/settings",
        },
        account.idTokenClaims.role === "admin" && {
          name: "Lite Doc Configuration",
          link: "/lite-doc/settings",
        },
      ] as itemType[],
    },
    {
      text: "Marketing",
      comingSoon: !isMindMatrixEnabled,
      items: [
        {
          name: CONTENT_CATEGORIES.productSalesEmails,
          link: CONTENT_URL_PATHS.productSalesEmails,
        },
        {
          name: CONTENT_CATEGORIES.thoughtLeadershipEmails,
          link: CONTENT_URL_PATHS.thoughtLeadershipEmails,
        },
        {
          name: CONTENT_CATEGORIES.productSummaries,
          link: CONTENT_URL_PATHS.productSummaries,
        },
        {
          name: CONTENT_CATEGORIES.blogs,
          link: CONTENT_URL_PATHS.blogs,
        },
      ] as itemType[],
    },
    {
      text: "Resources",
      comingSoon: !isMindMatrixEnabled,
      items: [
        {
          name: CONTENT_CATEGORIES.industryReportsAndInsights,
          link: CONTENT_URL_PATHS.industryReportsAndInsights,
        },
        {
          name: CONTENT_CATEGORIES.privacyAndOtherForms,
          link: CONTENT_URL_PATHS.privacyAndOtherForms,
        },
      ] as itemType[],
    },
    {
      text: "Help",
      items: [],
      link: "https://www.scotpac.com.au/partner-portal/",
      inNewTab: true,
    },
  ];

  return nav;
};
const staffNavOptions = [
  {
    text: "Sign out",
    items: [],
    link: "/logout",
  },
];

export { loggedInNavOptions, staffNavOptions };
